import { render, staticRenderFns } from "./TemplateLibraryNavButton.vue?vue&type=template&id=58bc435a&scoped=true&"
import script from "./TemplateLibraryNavButton.vue?vue&type=script&lang=js&"
export * from "./TemplateLibraryNavButton.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLibraryNavButton.vue?vue&type=style&index=0&id=58bc435a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc435a",
  null
  
)

export default component.exports